<template>
    <b-badge :variant="status.variant">{{status.text}}</b-badge>
</template>

<script>
import { BBadge } from 'bootstrap-vue'

export default {
    components:{
        BBadge
    },
    props:{
        fields:[String,Number],
        row:Object
    },
    computed:{
        status(){
            if(this.row.CariEmail){
                if(this.row.IsHasUser) {
                    if(this.row.IsUserEmailConfirmed){
                        return {
                            variant:'success',
                            text:'Cari kullanıcı oluşturulmuştur.'
                        }
                    }else return {
                        variant:'warning',
                        text:'Cari e-postası doğrulanmamıştır.'
                    }
                }else return {
                    variant:'secondary',
                    text:'Cari kullanıcı oluşturulmamış.'
                }
            }else return {
                variant:'danger',
                text:'Cari e-posta bilgisi eksik.'
            }
        }
    }
}
</script>